/**
 * Cache Busting Utility
 * Força atualização de dados quando necessário
 */

export const cacheUtils = {
  /**
   * Gera um token de cache busting baseado em timestamp
   * Use em URLs de imagens/vídeos para forçar recarregamento
   */
  getCacheBustToken: () => {
    return Math.floor(Date.now() / 60000); // Muda a cada minuto
  },

  /**
   * Adiciona cache busting a uma URL
   */
  addCacheBustToUrl: (url) => {
    if (!url) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${cacheUtils.getCacheBustToken()}`;
  },

  /**
   * Limpa cache do navegador (força recarregamento de dados)
   */
  clearAppCache: async () => {
    try {
      // Limpar Service Workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let registration of registrations) {
          await registration.unregister();
        }
      }

      // Limpar Cache API
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(cacheName => caches.delete(cacheName))
        );
      }

      // Force reload
      window.location.reload(true);
    } catch (error) {
      console.error('Erro ao limpar cache:', error);
      // Fallback: just reload
      window.location.reload();
    }
  }
};
